import { SkinActionTypes } from '../action-types/skinTypes';
import { SkinActions } from '../actions/skinTypes';

const trimHexColor = (cssValue: string) => {
  return cssValue.trim().substring(0, 7);
};

export const initialState: SkinState = {
  globalConfig: {
    showLogo: true,
    primary: {
      defaultBackground: '#fff',
      activeBackground: '#d2eaec',
      text: '#424242',
    },
    secondary: {
      promotion: '#0e6d60',
      promotion2: '#009284',
      error: '#ff0000',
    },
  },
  headerConfig: { background: '#4292a4', text: '#fff' },
  navigationConfig: { background: '#a4d8de', activeBackground: '#fff', text: '#009cb4' },
  buttonNavConfig: {
    default: { background: '#a42c66', inactiveBackground: '#f8f8f8', text: '#575757' },
    active: { background: '#8e0038', inactiveBackground: '#efe7ed', text: '#fff' },
  },
  componentConfig: {
    primary: { color1: '#8e0038', color2: '#424242', color3: '#efe7ed' },
    secondary: { color1: '#fff', color2: '#a42c66', color3: '#000' },
  },
  footerConfig: {
    default: { background: '#d2eaec', link: '#4292a4', text: '#424242' },
    active: { background: '#fff', link: '#4292a4', text: '#424242' },
  },
};

const skinReducer = (state: SkinState = initialState, action: SkinActions) => {
  switch (action.type) {
    case SkinActionTypes.SET_SKIN: {
      const newSkin = { ...state };
      if (action.payload.globalConfig) {
        if (typeof action.payload.globalConfig.showLogo === 'boolean') {
          newSkin.globalConfig.showLogo = action.payload.globalConfig.showLogo;
        }
        if (action.payload.globalConfig.primary) {
          if (typeof action.payload.globalConfig.primary.activeBackground === 'string') {
            newSkin.globalConfig.primary.activeBackground = trimHexColor(
              action.payload.globalConfig.primary.activeBackground,
            );
          }
          if (typeof action.payload.globalConfig.primary.defaultBackground === 'string') {
            newSkin.globalConfig.primary.defaultBackground = trimHexColor(
              action.payload.globalConfig.primary.defaultBackground,
            );
          }
          if (typeof action.payload.globalConfig.primary.text === 'string') {
            newSkin.globalConfig.primary.text = trimHexColor(
              action.payload.globalConfig.primary.text,
            );
          }
        }
        if (action.payload.globalConfig.secondary) {
          if (typeof action.payload.globalConfig.secondary.promotion === 'string') {
            newSkin.globalConfig.secondary.promotion = trimHexColor(
              action.payload.globalConfig.secondary.promotion,
            );
          }
          if (typeof action.payload.globalConfig.secondary.promotion2 === 'string') {
            newSkin.globalConfig.secondary.promotion2 = trimHexColor(
              action.payload.globalConfig.secondary.promotion2,
            );
          }
          if (typeof action.payload.globalConfig.secondary.error === 'string') {
            newSkin.globalConfig.secondary.error = trimHexColor(
              action.payload.globalConfig.secondary.error,
            );
          }
        }
        if (action.payload.headerConfig) {
          if (typeof action.payload.headerConfig.background === 'string') {
            newSkin.headerConfig.background = trimHexColor(action.payload.headerConfig.background);
          }
          if (typeof action.payload.headerConfig.text === 'string') {
            newSkin.headerConfig.text = trimHexColor(action.payload.headerConfig.text);
          }
        }
        if (action.payload.navigationConfig) {
          if (typeof action.payload.navigationConfig.background === 'string') {
            newSkin.navigationConfig.background = trimHexColor(
              action.payload.navigationConfig.background,
            );
          }
          if (typeof action.payload.navigationConfig.activeBackground === 'string') {
            newSkin.navigationConfig.activeBackground = trimHexColor(
              action.payload.navigationConfig.activeBackground,
            );
          }
          if (typeof action.payload.navigationConfig.text === 'string') {
            newSkin.navigationConfig.text = trimHexColor(action.payload.navigationConfig.text);
          }
        }
        if (action.payload.buttonNavConfig) {
          if (action.payload.buttonNavConfig.active) {
            if (typeof action.payload.buttonNavConfig.active.background === 'string') {
              newSkin.buttonNavConfig.active.background = trimHexColor(
                action.payload.buttonNavConfig.active.background,
              );
            }
            if (typeof action.payload.buttonNavConfig.active.inactiveBackground === 'string') {
              newSkin.buttonNavConfig.active.inactiveBackground = trimHexColor(
                action.payload.buttonNavConfig.active.inactiveBackground,
              );
            }
            if (typeof action.payload.buttonNavConfig.active.text === 'string') {
              newSkin.buttonNavConfig.active.text = trimHexColor(
                action.payload.buttonNavConfig.active.text,
              );
            }
          }
          if (action.payload.buttonNavConfig.default) {
            if (typeof action.payload.buttonNavConfig.default.background === 'string') {
              newSkin.buttonNavConfig.default.background = trimHexColor(
                action.payload.buttonNavConfig.default.background,
              );
            }
            if (typeof action.payload.buttonNavConfig.default.inactiveBackground === 'string') {
              newSkin.buttonNavConfig.default.inactiveBackground = trimHexColor(
                action.payload.buttonNavConfig.default.inactiveBackground,
              );
            }
            if (typeof action.payload.buttonNavConfig.default.text === 'string') {
              newSkin.buttonNavConfig.default.text = trimHexColor(
                action.payload.buttonNavConfig.default.text,
              );
            }
          }
        }
        if (action.payload.componentConfig) {
          if (action.payload.componentConfig.primary) {
            if (typeof action.payload.componentConfig.primary.color1 === 'string') {
              newSkin.componentConfig.primary.color1 = trimHexColor(
                action.payload.componentConfig.primary.color1,
              );
            }
            if (typeof action.payload.componentConfig.primary.color2 === 'string') {
              newSkin.componentConfig.primary.color2 = trimHexColor(
                action.payload.componentConfig.primary.color2,
              );
            }
            if (typeof action.payload.componentConfig.primary.color3 === 'string') {
              newSkin.componentConfig.primary.color3 = trimHexColor(
                action.payload.componentConfig.primary.color3,
              );
            }
          }
          if (action.payload.componentConfig.secondary) {
            if (typeof action.payload.componentConfig.secondary.color1 === 'string') {
              newSkin.componentConfig.secondary.color1 = trimHexColor(
                action.payload.componentConfig.secondary.color1,
              );
            }
            if (typeof action.payload.componentConfig.secondary.color2 === 'string') {
              newSkin.componentConfig.secondary.color2 = trimHexColor(
                action.payload.componentConfig.secondary.color2,
              );
            }
            if (typeof action.payload.componentConfig.secondary.color3 === 'string') {
              newSkin.componentConfig.secondary.color3 = trimHexColor(
                action.payload.componentConfig.secondary.color3,
              );
            }
          }
        }
        if (action.payload.footerConfig) {
          if (action.payload.footerConfig.default) {
            if (typeof action.payload.footerConfig.default.background === 'string') {
              newSkin.footerConfig.default.background = trimHexColor(
                action.payload.footerConfig.default.background,
              );
            }
            if (typeof action.payload.footerConfig.default.link === 'string') {
              newSkin.footerConfig.default.link = trimHexColor(
                action.payload.footerConfig.default.link,
              );
            }
            if (typeof action.payload.footerConfig.default.text === 'string') {
              newSkin.footerConfig.default.text = trimHexColor(
                action.payload.footerConfig.default.text,
              );
            }
          }
          if (action.payload.footerConfig.active) {
            if (typeof action.payload.footerConfig.active.background === 'string') {
              newSkin.footerConfig.active.background = trimHexColor(
                action.payload.footerConfig.active.background,
              );
            }
            if (typeof action.payload.footerConfig.active.link === 'string') {
              newSkin.footerConfig.active.link = trimHexColor(
                action.payload.footerConfig.active.link,
              );
            }
            if (typeof action.payload.footerConfig.active.text === 'string') {
              newSkin.footerConfig.active.text = trimHexColor(
                action.payload.footerConfig.active.text,
              );
            }
          }
        }
      }
      return newSkin;
    }

    case SkinActionTypes.SET_GLOBAL_CONFIG:
      return { ...state, globalConfig: action.payload };
    case SkinActionTypes.SET_HEADER_CONFIG:
      return { ...state, headerConfig: action.payload };
    case SkinActionTypes.SET_NAVIGATION_CONFIG:
      return { ...state, navigationConfig: action.payload };
    case SkinActionTypes.SET_BUTTON_NAV_CONFIG:
      return { ...state, buttonNavConfig: action.payload };
    case SkinActionTypes.SET_COMPONENT_CONFIG:
      return { ...state, componentConfig: action.payload };
    case SkinActionTypes.SET_FOOTER_CONFIG:
      return { ...state, footerConfig: action.payload };
    default:
      return state;
  }
};

export default skinReducer;
